import { Pipe, PipeTransform } from '@angular/core';
import { I18nService } from '../../core/services/i18n.service';

/**
 * Translate an English source string, e.g. {{ 'Add to cart' | t }}.
 * Impure so it re-evaluates when the language toggles.
 */
@Pipe({ name: 't', standalone: true, pure: false })
export class TranslatePipe implements PipeTransform {
  constructor(private i18n: I18nService) {}
  transform(value: string | null | undefined): string {
    return this.i18n.t(value);
  }
}
